module.exports = __webpack_public_path__ + "static/careRating-76154f0309fd4036a39ad567062d40b0.svg";